import {Select} from "@bolteu/clay-react";
import styled from "styled-components";

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
`;

// The popup otherwise anchors to the (now narrow) trigger width; size it to its own
// content so the language names aren't clipped.
export const LocalePopup = styled(Select.Popup)`
    width: max-content;
    min-width: 180px;
`;
